<template>
    <FullFillBox
        :pageID="1025"
        @permissionData="(data) => {
            this.permissionDetails = data
            if(data.edit === 1){
                this.showEditButton = true
            }
        }"
    >
        <h3>{{ $t('sys_online_user') }}</h3>
        <p>{{ $t('sys_total_user_license') }} {{ totalLicense }}</p>

        <div ref="tabulatorTableUse"></div>

        <button class="btn btn-primary" style="margin: 10px auto"
                @click="kickUser(0, 0, 'all')"
        >
            {{ $t('sys_logout_all') }}
        </button>
    </FullFillBox>
</template>

<script>
import FullFillBox from "@/components/routerViewLocation/FullFillBox";
import {TabulatorFull as Tabulator} from "tabulator-tables";
export default {
    name: "SystemUserOnlineListView",
    components: {
        FullFillBox
    },
    data(){
        return{
            permissionDetails: {},
            showEditButton: false,
            perResult: '',
            totalLicense: '',
        }
    },
    methods: {

        async kickUser(onlineID, userID, flag){
            await this.$swal.fire({
                title: this.$t('sys_kick_user'),
                icon: 'warning',
            }).then(async (result) => {
                if (result.isConfirmed) {
                    let postData = {
                        "adminUserID": this.$store.state.userServerID,
                        "kick_flag": flag,
                        "kick_user_online_pk": onlineID,
                        "user_id": userID,
                        "is_action_code": "f",
                        "action_code": "qweqwe",
                    }
                    await this.$mainApi.post('api/client/kick/', postData)
                        .then(response => {
                            if (response.data.status === 80) {
                                // Success
                                this.getBackendData()
                                this.$toast.success(this.$t('common_success'))
                            } else {
                                this.$toast.error("Something goes wrong: " + response.data)
                            }
                        })
                }
            })
        },
        async getBackendData(){
            this.$store.commit('setIsTopLoading', true)
            await this.$mainApi.get('api/client/online-list/')
                .then(response => {
                    if(response.data.status === 80){
                        this.totalLicense = response.data.details.license_no
                        this.tabulator.setData(response.data.details.user_data)
                    }
                })
            this.$store.commit('setIsTopLoading', false)
        },
        subTrashBinIcon(cell, formatterParams){
            return "<i class=\"bi bi-x-square-fill\"></i>";
        },
    },
    async mounted() {
        document.title = this.$t('title') + ' | ' + this.$t('now_online_user_table')
        this.tabulator = new Tabulator(this.$refs.tabulatorTableUse, {
            placeholder: "<h3>" + this.$t('common_no_data') + "</h3>",
            maxHeight: '80vh',
            responsiveLayout: 'collapse',
            layout: "fitColumns",
            movableColumns: true,
            movableRows: false,
            groupStartOpen: false,
            data: [],
            columns: [
                {
                    width:50, responsive:0,
                    title: "id",
                    field: "id",
                },
                {
                    width:200, responsive:0,
                    title: this.$t('table_show_name'),
                    field: "user",
                    sorter: "string",
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {
                    widthGrow:1, responsive:5, minWidth: 100,
                    title: this.$t('table_ip'),
                    field: "ip",
                    sorter: "string",
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {
                    widthGrow:1, responsive:5, minWidth: 100,
                    title: this.$t('sys_role'),
                    field: "role",
                    sorter: "string",
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {
                    widthGrow:2, responsive:5, minWidth: 300,
                    title: this.$t('sys_login_device'),
                    field: "device",
                    sorter: "string",
                    formatter: "textarea",
                    headerFilter:"list",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {
                    widthGrow:1, responsive:0, minWidth: 50,
                    title: this.$t('sys_login_tools'),
                    field: "tool",
                    sorter: "number",
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {
                    widthGrow:1, responsive:5, minWidth: 50,
                    title: this.$t('sys_last_active'),
                    field: "lastActiveTime",
                    sorter: "string",
                    headerFilter:"list",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {
                    visible: false,
                    title: "user_id",
                    field: "user_id",
                },
                {formatter: this.subTrashBinIcon, headerHozAlign:"center",
                    hozAlign:"center", vertAlign: "middle", resizable:false,
                    width:10, responsive:0, headerSort:false, headerMenu: this.getHeaderMenu,
                    cellClick: (e, cell) => {
                        if(this.showEditButton){
                            this.kickUser(cell.getRow().getData().id, cell.getRow().getData().user_id, "single")
                        }else{
                            this.$toast.error(this.$t('error_no_permission'))
                        }
                    },
                },
            ],
        })
        await this.getBackendData()
    }
}
</script>

<style scoped>

</style>
